var body = $("html, body");

$(".gallery-thumbnail-item img").waitUntilExists(function () {
  $('[data-toggle="modal"]').on("click", function () {
    body.stop().animate({ scrollTop: 0 }, 500, "swing");
  });
});
